import type { BoxProps } from '@chakra-ui/react'
import { Box, Button, Grid, HStack } from '@chakra-ui/react'
import { DateFormControl, InputFormControl, SelectFormControl, SwitchFormControl } from 'BrokerTsLib/src/components'
import { FormProvider, useForm } from 'BrokerTsLib/src/rhf'
import { useContext, useEffect } from 'react'

import { ppzAuthorizationListContext } from '@/context/PpzAuthorizationListContext'
import type { PpzAuthorizationPagedQuery } from '@/dtos'
import { PpzAuthorizationListTypes } from '@/dtos/PpzAuthorization/PpzAuthorizationListType'
import { Search } from '@/icons'

export const PpzAuthorizationListFilter = (props: BoxProps) => {
  const { filter, updateFilter } = useContext(ppzAuthorizationListContext)

  const methods = useForm<PpzAuthorizationPagedQuery>()
  const { handleSubmit, control, reset } = methods

  useEffect(() => {
    reset(filter)
  }, [filter, reset])

  const handleFormSubmit = (data: PpzAuthorizationPagedQuery) => {
    updateFilter({...data, pageIndex: 1})
  }

  return <FormProvider {...methods}>
    <Box as='form' onSubmit={handleSubmit(handleFormSubmit)} {...props}>
      <Grid gap={4} templateColumns={{ base: '1fr', sm: 'repeat(2, minmax(0, 1fr))', lg: 'repeat(3, minmax(0, 1fr))' }} alignItems='center'>
        <SelectFormControl name="listType" control={control}
          label="Zobrazené záznamy"
          options={PpzAuthorizationListTypes.map(x => ({
            value: x[0],
            label: x[1]
          }))}
          gridColumn={{ base: '1', sm: '1 / span 2' }}
        />
        <InputFormControl name="name" control={control} label="Jméno uživatele" />

        <DateFormControl name="dateCreatedFrom" control={control} label="Datum vytvoření - od" />
        <DateFormControl name="dateCreatedTo" control={control} label="Datum vytvoření - do" />
        <SwitchFormControl name="showInvalidUsers" control={control} label="Zobrazit i neaktivní uživatele" alignSelf='end' pb={2.5} />

        <DateFormControl name="validToFrom" control={control} label="Platnost do - od" />
        <DateFormControl name="validToTo" control={control} label="Platnost do - do" />
        <Button type="submit" alignSelf='end' ml='auto' size='lg' w='full'>
          <HStack gap={2}>
            <Search />
            <Box>Filtrovat</Box>
          </HStack>
        </Button>
      </Grid>
    </Box>
  </FormProvider>
}